import "firebase/auth";
import {
    auth,
    googleProvider,
    signinWithPopup,
    signinWithPhoneNumber,
    RecaptchaVerifier,
} from "./Firebase.service";

declare global {
    interface Window {
        recaptchaVerifier?: any;
    }
}

const FirebaseAuthService = {
    signinWithGoogle: async () => {
        try {
            return await signinWithPopup(auth, googleProvider);
        } catch (err) {
            console.log(err);
            return false;
        }
    },
    signinWithPhoneNumber: async (phoneNumber: string) => {
        try {
            const appVerifier = new RecaptchaVerifier(
                auth,
                "recaptcha-container",
                {}
            );
            return await signinWithPhoneNumber(auth, phoneNumber, appVerifier);
        } catch (err) {
            console.log(err);
            return false;
        }
    },
    confirmOTPToSigninWithPhoneNumber: async (
        confirmationResult: any,
        otp: string
    ) => {
        try {
            return await confirmationResult.confirm(otp);
        } catch (err) {
            console.log(err);
            return false;
        }
    },
};

export default FirebaseAuthService;
